export default __webpack_public_path__ + "static/media/ellipse_23321.252a9c1b.png";